import { TEntityUntagged } from '@obvious.tech/constellation/Entity'
import { TEntityOverride } from 'src/types'

const override: TEntityOverride<TEntityUntagged<'AnalyticsCamera'>> = {
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
      id: {
        displayedName: 'ID',
      },
      cameraReference: {
        displayedName: 'Camera',
        type: 'object',
        reference: {
          target: 'Camera',
          idKeyPath: 'id',
          labelKeyPath: 'name',
          targetLabelKeyPath: 'name',
        },
      },
    },
  },
}

export default override
